// TODO: Move this file out of pixiComponents folder since it no longer is part of a pixi.js control.
export function getNumSliderValues(minValue, maxValue, increment) {
    return Math.ceil((maxValue - minValue) / increment) + 1;
}
export function getSliderValueFromXPosition(positionX, totalWidth, buttonWidth, minValue, maxValue, increment) {
    const sliderXRange = totalWidth - buttonWidth;
    const numValues = getNumSliderValues(minValue, maxValue, increment);
    if (numValues <= 1) {
        return minValue;
    }
    const value = Math.min(minValue + Math.round((positionX / sliderXRange) * (numValues - 1)) * increment, maxValue);
    return value;
}
export function getSliderValueFromRawValue(rawValue, minValue, maxValue, increment) {
    if (rawValue < minValue) {
        return minValue;
    }
    if (rawValue > maxValue) {
        return maxValue;
    }
    let currLeftValue = minValue;
    while (currLeftValue < maxValue) {
        const currRightValue = Math.min(currLeftValue + increment, maxValue);
        if (rawValue >= currLeftValue && rawValue <= currRightValue) {
            if (rawValue === currLeftValue) {
                return currLeftValue;
            }
            if (rawValue === currRightValue) {
                return currRightValue;
            }
            if (rawValue - currLeftValue < currRightValue - rawValue) {
                // closer to left value than the right
                return currLeftValue;
            }
            else {
                // closer to right value than the left
                return currRightValue;
            }
        }
        currLeftValue += increment;
    }
    // probably should not reach this point without returning earlier
    return maxValue;
}
export function getXPositionFromValue(value, totalWidth, sliderButtonWidth, minValue, maxValue, increment) {
    const maxXPosition = totalWidth - sliderButtonWidth;
    const relativeValue = value - minValue;
    const stepIndex = Math.ceil(relativeValue / increment);
    const numSliderValues = getNumSliderValues(minValue, maxValue, increment);
    if (stepIndex >= numSliderValues - 1) {
        // at the last step, so return the maximum X value, since this step may not contain a full increment amount
        return maxXPosition;
    }
    const relativeValueRange = maxValue - minValue;
    return ((stepIndex * increment) / relativeValueRange) * maxXPosition;
}
export function getNearestStepX(x, maxX, numValues) {
    if (x <= 0 || numValues <= 1) {
        return 0;
    }
    if (x >= maxX) {
        return maxX;
    }
    const xWidthPerValue = maxX / (numValues - 1);
    return Math.round(x / xWidthPerValue) * xWidthPerValue;
}
